import "babel-polyfill";

import { Analytics } from "./Analytics";
window.Analytics = Analytics;